import { datepicker } from 'vue-strap'
import { visible } from './controls'

// Keep the existing date format/parser and provide a keyboard path into every view.
export default {
    extends: datepicker,
    inheritAttrs: false,
    mounted () {
        this.syncAccessibility()
        this.$el.addEventListener('keydown', this.onCalendarKey)
    },
    updated () { this.syncAccessibility() },
    beforeDestroy () { this.$el.removeEventListener('keydown', this.onCalendarKey) },
    methods: {
        syncAccessibility () {
            const input = this.$el.querySelector('input')
            const open = this.displayDayView || this.displayMonthView || this.displayYearView
            input.id = this.$attrs.id || 'tone-date-' + this._uid
            input.setAttribute('aria-label', this.$attrs['aria-label'] || this.placeholder || 'Date')
            input.setAttribute('role', 'combobox')
            input.setAttribute('aria-expanded', open ? 'true' : 'false')
            input.setAttribute('aria-haspopup', 'dialog')
            if (this.$attrs['aria-describedby']) input.setAttribute('aria-describedby', this.$attrs['aria-describedby'])
            let active
            Array.prototype.forEach.call(this.$el.querySelectorAll('.datepicker-popup'), (popup, index) => {
                popup.id = 'tone-calendar-' + this._uid + '-' + index
                popup.setAttribute('role', 'dialog')
                popup.setAttribute('aria-label', ['Choose day', 'Choose month', 'Choose year'][index])
                if (visible(popup)) active = popup
                const controls = popup.querySelectorAll('.datepicker-ctrl span, .datepicker-ctrl p, .datepicker-dateRange span, .datepicker-monthRange span')
                Array.prototype.forEach.call(controls, control => {
                    // The decade heading is informational, unlike day/month headings.
                    if (index === 2 && control.tagName === 'P') return
                    control.removeAttribute('aria-hidden')
                    control.setAttribute('role', 'button')
                    const disabled = control.classList.contains('datepicker-item-disable')
                    control.setAttribute('tabindex', disabled ? '-1' : '0')
                    control.setAttribute('aria-disabled', disabled ? 'true' : 'false')
                    if (!control.textContent.trim()) {
                        const previous = control === popup.querySelector('.datepicker-ctrl span')
                        control.setAttribute('aria-label', (previous ? 'Previous ' : 'Next ') + ['month', 'year', 'decade'][index])
                    }
                })
                if (index === 0) {
                    Array.prototype.forEach.call(popup.querySelectorAll('.datepicker-dateRange span'), (control, day) => {
                        const value = this.dateRange[day]
                        if (value) control.setAttribute('aria-label', value.date.toDateString())
                        control.setAttribute('aria-pressed', control.classList.contains('datepicker-dateRange-item-active') ? 'true' : 'false')
                    })
                }
            })
            const clear = this.$el.querySelector('button.close')
            if (clear) clear.setAttribute('aria-label', 'Clear date')
            if (active) input.setAttribute('aria-controls', active.id)
            else input.removeAttribute('aria-controls')
            if (open && active && this.$el.contains(document.activeElement) && !visible(document.activeElement)) {
                const first = active.querySelector('[role="button"][tabindex="0"]')
                if (first) first.focus()
            }
            if (!open && this._calendarWasOpen && this.$el.contains(document.activeElement) && document.activeElement !== input) input.focus()
            this._calendarWasOpen = open
        },
        onCalendarKey (event) {
            const input = this.$el.querySelector('input')
            if (event.key === 'Escape') {
                event.preventDefault()
                this.close()
                input.focus()
            } else if (event.target === input && event.key === 'ArrowDown') {
                event.preventDefault()
                this.displayDayView = true
                this.$nextTick(() => {
                    const first = Array.prototype.filter.call(this.$el.querySelectorAll('.datepicker-popup [role="button"]'), visible)[0]
                    if (first) first.focus()
                })
            } else if (event.target.getAttribute('role') === 'button' && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault()
                if (!event.repeat && event.target.getAttribute('aria-disabled') !== 'true') event.target.click()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Datepicker.js